import formatNumber from '@framework/data-helpers/formatters/formatNumber';
import type { IFilterTag } from '../types';
import type { IRangeConfig } from '../configs';

const getRangeTags = <TFilters, TBoundaries>(
  configs: IRangeConfig<TFilters, TBoundaries>[],
  filters: TFilters,
  boundaries: TBoundaries | null,
): IFilterTag[] =>
  configs.flatMap(({ key, fromKey, toKey, boundaryKey, label, isExclude = false }) => {
    const from = filters[fromKey] as number | null;
    const to = filters[toKey] as number | null;
    if (from === null && to === null) return [];
    const bounds = boundaries?.[boundaryKey] as { min: number, max: number } | null;
    const displayFrom = formatNumber(from ?? bounds?.min ?? 0);
    const displayTo = formatNumber(to ?? bounds?.max ?? 0);
    return [{ key, label: `${ label }: ${ displayFrom }–${ displayTo }`, isExclude, removable: true }];
  });

export default getRangeTags;
